import { filterClasses } from "@swivl-mono/helpers";
import { Button, ButtonColor, ButtonVariant } from "@swivl-mono/ui";

import { openAccountSettings } from "../../../../../App/Layout/NavBar/Components/AccountSettingsModal/AccountSettingsModal";
import { AccountSettingsTab } from "../../../../../App/Layout/NavBar/Components/AccountSettingsModal/AccountSettingsTabs";

interface EnablePushNotificationsCardProps {
  hasEscalations?: boolean;
  onDefer: () => void;
  /**
   * Corner-radius utility. Dedicated props rather than one general `className`
   * because `filterClasses` only concatenates — a passed-in `rounded-sm` would
   * lose to the base `rounded-lg` on CSS order, not on attribute order.
   * CC v3 squares this to match its list chrome (ENG-3020).
   */
  radiusClassName?: string;
  /** Gap between the message and the buttons — see `radiusClassName` for why it's its own prop. */
  gapClassName?: string;
}

const EnablePushNotificationsCard = ({
  hasEscalations,
  onDefer,
  radiusClassName = "rounded-lg",
  gapClassName = "gap-4"
}: EnablePushNotificationsCardProps) => {
  const handleOpenNotificationSettings = () => {
    sessionStorage.removeItem("defer-push-notifications");
    openAccountSettings(AccountSettingsTab.NOTIFICATIONS);
  };

  const handleDeferNotification = () => {
    sessionStorage.setItem("defer-push-notifications", "true");
    onDefer();
  };

  return (
    <div
      className={filterClasses(
        // Row layout when escalations are present; stacked otherwise. `flex-wrap`
        // lets the buttons drop below the text in a narrow column (v3 is 288px)
        // instead of squishing/clipping — a wide column (v2) still fits one row,
        // so it's unchanged there. No fixed max-height (it clipped the wrap).
        !hasEscalations && "flex-col",
        "mb-4 flex w-full flex-wrap items-center border border-orange-500 bg-orange-50 p-4 text-center text-sm text-black",
        radiusClassName,
        gapClassName,
        "transition duration-200 ease-in-out"
      )}
    >
      <p>Turn on desktop notifications {!hasEscalations && "so you never miss an escalation"}</p>

      <div className="flex gap-2">
        <Button variant={ButtonVariant.GHOST} onClick={handleDeferNotification}>
          {!hasEscalations && "Maybe"} Later
        </Button>
        <Button color={ButtonColor.ORANGE} onClick={handleOpenNotificationSettings}>
          Turn On
        </Button>
      </div>
    </div>
  );
};

export default EnablePushNotificationsCard;
